import maneuverRoutes from './routes'

/* @ngInject */
const maneuverRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(maneuverRoutes.index.path, {
      url: maneuverRoutes.index.url,
      template: require('./templates/index.html'),
      data: {
        pageTitle: 'Manœuvrer',
      },
    })
}

export default maneuverRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/maneuver.routes.js